import { supabase } from './supabase';

const GUEST_KEY = 'bl_reactions';

// ── Set (or clear) a reaction ─────────────────────────────────────────────────
// reaction: 'like' | 'dislike' | null (null removes the reaction)
export async function setReaction({ userId, isGuest, contentKey, contentType, subject, title, reaction }) {
  if (isGuest || !userId) {
    const reactions = _guestRead();
    if (reaction === null) {
      delete reactions[contentKey];
    } else {
      reactions[contentKey] = { contentKey, contentType, subject, title, reaction, created_at: new Date().toISOString() };
    }
    _guestWrite(reactions);
    return { error: null };
  }

  if (reaction === null) {
    return supabase.from('content_reactions').delete()
      .eq('user_id', userId).eq('content_key', contentKey);
  }

  return supabase.from('content_reactions')
    .upsert(
      { user_id: userId, content_key: contentKey, content_type: contentType, subject, title, reaction },
      { onConflict: 'user_id,content_key' }
    );
}

// ── Get the reaction for a single content item ────────────────────────────────
export async function getReaction({ userId, isGuest, contentKey }) {
  if (isGuest || !userId) {
    const reactions = _guestRead();
    return { data: reactions[contentKey] || null, error: null };
  }

  const { data, error } = await supabase
    .from('content_reactions')
    .select('reaction')
    .eq('user_id', userId)
    .eq('content_key', contentKey)
    .maybeSingle();
  return { data, error };
}

// ── Get a summary of what the user has liked/disliked (for curation) ──────────
export async function getReactionSummary({ userId, isGuest, limit = 15 }) {
  if (isGuest || !userId) {
    const reactions = Object.values(_guestRead());
    const liked    = [...new Set(reactions.filter(r => r.reaction === 'like').map(r => r.subject))].slice(0, limit);
    const disliked = [...new Set(reactions.filter(r => r.reaction === 'dislike').map(r => r.subject))].slice(0, limit);
    return { data: { liked, disliked }, error: null };
  }

  const { data, error } = await supabase
    .from('content_reactions')
    .select('subject, reaction')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })
    .limit(limit * 2);

  if (error) return { data: { liked: [], disliked: [] }, error };

  const liked    = [...new Set((data || []).filter(r => r.reaction === 'like').map(r => r.subject))].slice(0, limit);
  const disliked = [...new Set((data || []).filter(r => r.reaction === 'dislike').map(r => r.subject))].slice(0, limit);
  return { data: { liked, disliked }, error: null };
}

// ── Guest localStorage helpers ────────────────────────────────────────────────
function _guestRead() {
  try { return JSON.parse(localStorage.getItem(GUEST_KEY) || '{}'); } catch { return {}; }
}
function _guestWrite(obj) {
  try { localStorage.setItem(GUEST_KEY, JSON.stringify(obj)); } catch {}
}
